import React from 'react';
import { LoadDropdown, DefaultDropdownProps } from 'framework/form';
import useEmployeeSkillsNamesService, { EmployeeSkillsNamesType } from '../../../useEmployeeSkillsNamesService';

const EmployeeSkillsDropdown = ({ source, ...props }: DefaultDropdownProps) => {
  const { searchAll } = useEmployeeSkillsNamesService();
  const loadSkills = async () => {
    const result = (await searchAll()) as EmployeeSkillsNamesType[];

    return { result: result };
  };

  return (
    <LoadDropdown
      {...props}
      loadDataMethod={loadSkills}
      mapResults={skillValue => {
        return {
          value: skillValue.name,
          label: skillValue.name,
        };
      }}
      label=""
      placeholder="Skill"
      source={source}
    />
  );
};

export default EmployeeSkillsDropdown;
